import React from 'react';
import './Adverts.css';

const Adverts = () => {
  return (
    <div className="adverts">
      <span>30% off your first purchase</span>
    </div>
  );
};

export default Adverts;
